import './style.scss';
import { Separator } from 'views/components/atoms/separator';
import { Toast } from 'views/components/atoms/toast';
import { Button, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { TransitionButton } from 'views/components/atoms/transitionButton';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { NavLink } from 'react-router-dom';
import { useLogin } from './hook';
import { IconColor, IconSize, SvgIcon } from 'views/components/atoms/svgIcon';
import { IconName, findIcon } from 'views/utils/handleIcon';
import { LoginAccount } from 'views/components/molecules/loginAccount';
import { useRef, useState } from 'react';

export const Login = () => {
  const { isRevealPassword, togglePassword, formik, toastProps, onPasskeyLogin } = useLogin();
  const passwordRef = useRef<HTMLInputElement>(null);
  // パスワードのフォームを出すかどうか
  const [isPasswordLogin, setIsPasswordLogin] = useState<boolean>(false);
  // アイコンs
  const icon = findIcon(isRevealPassword ? IconName.EyeOn : IconName.EyeOff);
  const keyboadIcon = findIcon(IconName.Keyboad);
  const keyIcon = findIcon(IconName.Key);

  return (
    <form onSubmit={formik.handleSubmit} className="loginWrapper">
      <div className="fieldWrapper">
        <div className="loginInput">
          <LoginAccount
            branch={formik.values.branch}
            branchOnChange={formik.handleChange}
            account={formik.values.account}
            accountOnChange={formik.handleChange}
            nextFormRef={passwordRef}
          />
          {formik.errors.branch ? (
            <div className="errorRed">{formik.errors.branch}</div>
          ) : formik.errors.account ? (
            <div className="errorRed">{formik.errors.account}</div>
          ) : null}
        </div>

        {isPasswordLogin && (
          <div className="loginInput">
            <span className="loginInput_label">パスワード</span>
            <div className="loginInput_password">
              <input
                className="loginInput_field loginInput_password_value"
                type={isRevealPassword ? 'text' : 'password'}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                ref={passwordRef}
              />
              <span onClick={togglePassword} className="loginInput_password_action">
                <SvgIcon icon={icon} size={IconSize.icon_m} />
              </span>
            </div>
            {formik.errors.password ? <div className="errorRed">{formik.errors.password}</div> : null}
          </div>
        )}
      </div>

      <div className="fieldWrapper">
        {isPasswordLogin ? (
          <>
            <Button
              label="ログイン"
              type={ButtonType.Submit}
              fillType={FillType.primaryFill}
              buttonSize={ButtonSize.sizeM}
            />
            <NavLink to={CustomerPagePath.ReissuePassword}>
              <span className="forgot">パスワードをお忘れの方はこちら</span>
            </NavLink>
          </>
        ) : (
          <Button
            label="パスワードでログイン"
            type={ButtonType.Button}
            fillType={FillType.primaryFill}
            onClick={() => setIsPasswordLogin(true)}
            buttonSize={ButtonSize.sizeM}
            icon={
              <span className="loginIcon">
                <SvgIcon icon={keyboadIcon} size={IconSize.icon_m} color={IconColor.white} />
              </span>
            }
          />
        )}

        <Separator />

        <Button
          label="パスキーでログイン"
          type={ButtonType.Button}
          fillType={FillType.primaryFill}
          onClick={() => onPasskeyLogin(formik.values)}
          buttonSize={ButtonSize.sizeM}
          icon={
            <span className="loginIcon">
              <SvgIcon icon={keyIcon} size={IconSize.icon_m} color={IconColor.white} />
            </span>
          }
        />
        <a href={process.env.REACT_APP_WHAT_PASSKEY} target="_blank" rel="noreferrer noopener">
          <span className="forgot">パスキーとは</span>
        </a>
        <Separator />

        <div className="openAccount">
          <TransitionButton
            to={CustomerPagePath.AddvanceQuestion}
            label="口座開設"
            type={ButtonType.Submit}
            fillType={FillType.dangerFill}
            buttonSize={ButtonSize.sizeM}
          />
        </div>
        <span className="establishWrapper_description openAnnotation">
          ＜注意事項＞
          <br />
          ・日本語以外でのサービス提供は行っておりませんので、 ご留意ください
          <br />
          ・口座開設にあたり、スマートフォンを利用した本人確認（取引時確認）を実施いただいております
          <br />※ 動作環境については
          <a href={process.env.REACT_APP_OPERATING_ENVIRONMENT_URL} target="_blank" rel="noreferrer noopener">
            こちらから
          </a>
          ご確認いただけます
          <br />・
          <a
            href={process.env.REACT_APP_PURPOSE_OF_USE_OF_PERSONAL_INFORMATION_URL}
            target="_blank"
            rel="noreferrer noopener"
          >
            「個人情報の利用目的」
          </a>
          をご覧いただき、内容を十分ご理解・ご承諾いただいた上で、お申込みください
        </span>
      </div>

      <a href={process.env.REACT_APP_INQUIRY_URL} target="_blank" rel="noreferrer noopener">
        <span className="forgot">お問い合わせ</span>
      </a>

      <Toast {...toastProps} />
    </form>
  );
};
